<template>
    <Dialog :dialog="!!component" :header="title" @onClose="handleClose">
        <component :is="component" :props="props" :success-fn="onSuccess" @onClose="handleClose" />
    </Dialog>
</template>

<script>
import { DialogBus } from "./DialogBus";
import Dialog from "./Dialog";
export default {
    components: { Dialog },
    data () {
        return {
            component: null,
            title: "",
            props: null,
            onSuccess: null,
        };
    },
    created () {
        DialogBus.$on("open", ({ component, title = "", props = null, onSuccess }) => {
            this.component = component;
            this.title = title;
            this.props = props;
            this.onSuccess = onSuccess;
        });
        document.addEventListener("keyup", this.handleKeyup);
    },
    beforeDestroy () {
        document.removeEventListener("keyup", this.handleKeyup);
    },
    methods: {
        handleClose () {
            this.component = null;
        },
        handleKeyup (e) {
            if (e.keyCode === 27) this.handleClose();
        }
    },
};
</script>


// WEBPACK FOOTER //
// src/smallComponents/Dialog/DialogRoot.vue